/**
 * Reducer for obtaining flight routes
 */
import Constants from '../constants/PassengersConstants';
import { fromJS, List as IList } from 'immutable';

const initialState = IList();

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function passengers (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.PASSENGERS_REQUEST:
      return IList();

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.PASSENGERS_SUCCESS:
      if (action.data && action.data.length) {
        return fromJS(action.data);
      }
      return state;

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.PASSENGERS_FAILURE:
      return IList();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/PassengersReducer.js